// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__2NvTL","visibleHandle":"Handle_visibleHandle__20svt","dragged":"Handle_dragged__3yfpg"};